import { ICategoryContext, IFilterValues } from './categoryContext';

export enum CategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_CATEGORIES = 'SET_CATEGORIES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	TOGGLE_REMEMBER_MY_CHOICE = 'TOGGLE_REMEMBER_MY_CHOICE',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_IDS_SELECTED_CATEGORY_TYPES = 'SET_IDS_SELECTED_CATEGORY_TYPES',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ASSIGN_RESTAURANTS = 'SET_ID_FOR_ASSIGN_RESTAURANTS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface IRefetchData {
	type: CategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: ICategoryContext['needRefetchData'];
	};
}
interface ISetCategories {
	type: CategoryActionTypes.SET_CATEGORIES;
	payload: {
		categories: ICategoryContext['categories'];
		typeOfModalWindow: ICategoryContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: CategoryActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: ICategoryContext['searchString'];
	};
}

interface IToggleRememberMyChoice {
	type: CategoryActionTypes.TOGGLE_REMEMBER_MY_CHOICE;
	payload: {
		rememberMyChoice: ICategoryContext['rememberMyChoice'];
	};
}

interface ISetIDCustomer {
	type: CategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICategoryContext['IDSelectedCustomer'];
		categories: ICategoryContext['categories'];
	};
}

interface ISetIDRestaurant {
	type: CategoryActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: ICategoryContext['IDSelectedRestaurant'];
	};
}

interface ISetIDsSelectedCategoryType {
	type: CategoryActionTypes.SET_IDS_SELECTED_CATEGORY_TYPES;
	payload: {
		IDsSelectedCategoryTypes: ICategoryContext['IDsSelectedCategoryTypes'];
	};
}

interface IResetSelectedControls {
	type: CategoryActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: CategoryActionTypes.SET_SORT_BY;
	payload: {
		sortBy: ICategoryContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: CategoryActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: ICategoryContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: CategoryActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: ICategoryContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: CategoryActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: ICategoryContext['IDForDeletion'];
		typeOfModalWindow: ICategoryContext['typeOfModalWindow'];
	};
}

interface ISetIDForAssignRestaurant {
	type: CategoryActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS;
	payload: {
		IDForAssignRestaurants: ICategoryContext['IDForDeletion'];
		typeOfModalWindow: ICategoryContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICategoryContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: CategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TCategoryAction =
	| IRefetchData
	| ISetCategories
	| IChangeSearchString
	| IToggleRememberMyChoice
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDsSelectedCategoryType
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForAssignRestaurant
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
